import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute z-10 bg-gradient-to-b bottom-0 from-transparent to-black w-full h-1/2 opacity-70" }, null, -1)
const _hoisted_5 = { class: "absolute bottom-0 left-0 z-20" }
const _hoisted_6 = { class: "p-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-white text-left" }, "CATEGORY", -1)
const _hoisted_8 = { class: "text-xl text-white text-left" }
const _hoisted_9 = { class: "text-sm text-white text-left pt-4" }
const _hoisted_10 = { class: "p-4 pb-28" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_SVoucherCard = _resolveComponent("SVoucherCard")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_SBrowseFilter = _resolveComponent("SBrowseFilter")!
  const _component_SBottomBar = _resolveComponent("SBottomBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.categoryId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "aspect-square object-cover",
            src: _ctx.voucherCategory?.imageUrl,
            alt: ""
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.voucherCategory?.name), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.voucherCategory?.description), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_van_list, {
        loading: _ctx.isLoading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
        finished: _ctx.vouchers.isFinal,
        "finished-text": "",
        "loading-text": "loading",
        class: "space-y-4",
        onLoad: _ctx.loadMoreVouchers
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "finished", {}, () => [
            (!_ctx.vouchers.data.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_van_empty, { description: "表示できる特別優待はありません" })
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers.data, (voucher) => {
            return (_openBlock(), _createElementBlock("div", {
              key: voucher.voucherId
            }, [
              _createVNode(_component_SVoucherCard, { voucher: voucher }, null, 8, ["voucher"])
            ]))
          }), 128))
        ]),
        _: 3
      }, 8, ["loading", "finished", "onLoad"])
    ]),
    _createVNode(_component_SBrowseFilter),
    _createVNode(_component_SBottomBar)
  ]))
}